// 日期時間解析輔助函數
export const parseDateTime = (dateTimeStr) => {
  if (!dateTimeStr || dateTimeStr === 'null') return { date: '', time: '' }

  try {
    if (dateTimeStr.includes('2125')) {
      return { date: '', time: '', isNoEndTime: true }
    }

    // 處理格式：'2025/04/01 12:00:00' 或 '2025-04-01 12:00:00'
    const parts = dateTimeStr.split(' ')
    if (parts.length !== 2) return { date: '', time: '' }

    let [datePart, timePart] = parts

    // 統一日期格式為 YYYY-MM-DD（HTML input[type="date"] 需要的格式）
    if (datePart.includes('/')) {
      const [year, month, day] = datePart.split('/')
      datePart = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    // 時間格式為 HH:MM（移除秒數）
    timePart = timePart.slice(0, 5)

    return {
      date: datePart,
      time: timePart,
    }
  } catch (error) {
    console.error('解析日期時間失敗:', dateTimeStr, error)
    return { date: '', time: '' }
  }
}

// 獲取100年後的日期時間（當勾選無結束時間時使用）
export const get100YearsLater = (startDate, startTime) => {
  return {
    date: '2125-01-01',
    time: '00:00',
    fullDateTime: '2125-01-01 00:00:00',
  }
}

// 解析手機字串 -> 陣列（僅接受台灣 09 開頭 10 碼）
export const parsePhones = (str = '') =>
  str
    .split(/[\s,，\n\r]+/)
    .map((s) => s.trim())
    .filter(Boolean)
    .filter((s) => /^09\d{8}$/.test(s))

// 添加電話號碼格式處理函數（參考 contactsettings.js）
export const processPhoneNumber = (phone) => {
  if (!phone) return ''

  // 移除所有非數字字符
  let cleaned = phone.replace(/[^\d]/g, '')

  // 處理常見的台灣手機號碼格式
  if (cleaned.length === 9 && cleaned.startsWith('9')) {
    // 如果是 9 開頭的 9 碼，補上前面的 0
    cleaned = '0' + cleaned
  } else if (cleaned.length === 10 && cleaned.startsWith('09')) {
    // 標準格式，直接使用
    return cleaned
  } else if (cleaned.length === 11 && cleaned.startsWith('886')) {
    // 國際格式 +886，轉換為本地格式
    cleaned = '0' + cleaned.substring(3)
  } else if (cleaned.length === 12 && cleaned.startsWith('8869')) {
    // 完整國際格式 +8869，轉換為本地格式
    cleaned = '09' + cleaned.substring(4)
  }

  return cleaned
}

// 添加台灣手機號碼驗證函數（參考 contactsettings.js）
export const isValidTaiwanPhone = (phone) => {
  const phoneRegex = /^09\d{8}$/
  return phoneRegex.test(phone)
}

// 轉換 repeatOption 為 API 需要的數字格式
export const getRepeatValue = (repeatOption) => {
  switch (repeatOption) {
    case 'none':
      return 0
    case 'daily':
      return 1
    case 'weekly':
      return 2
    case 'monthly':
      return 3
    case 'yearly':
      return 4
    default:
      return 0
  }
}

// 將 API 的 renew 值轉換為前端 repeatOption 的函數
export const getRepeatOptionFromValue = (renewValue) => {
  switch (renewValue) {
    case 0:
      return 'none'
    case 1:
      return 'daily'
    case 2:
      return 'weekly'
    case 3:
      return 'monthly'
    case 4:
      return 'yearly'
    default:
      return 'none'
  }
}

// 獲取任務狀態文字
export const getStatusText = (status) => {
  switch (status) {
    case 'draft':
      return '(暫存中)'
    case 'active':
      return '(上架中)'
    case 'ended':
      return '(已結束)'
    case 'deleted':
      return '(已刪除)'
    default:
      return ''
  }
}

const taskUtils = {
  parseDateTime,
  get100YearsLater,
  parsePhones,
  processPhoneNumber,
  isValidTaiwanPhone,
  getRepeatValue,
  getRepeatOptionFromValue,
  getStatusText,
}

export default taskUtils
